


import type ITourDto from "@workspace/apiservice/src/model/TourDto.if";
import type { ITourSelectItemViewModel, ITourSelectViewModel } from "../../components/tourselect/interface";
import type { IBaseControllerRenderResult } from "../interface";


export interface IRouteTourSelectArguments {
    db: string;
    languageId: number;
    sessionName: string;
}

export interface ITourSelectControllerProps {
    didRequestTour: (id: number) => void;
    didRequestBack: () => void;
    route: IRouteTourSelectArguments;
}

export interface ITourSelectControllerRenderResult extends IBaseControllerRenderResult<{tour: ITourDto}> {}

export interface ITourSelectItemControllerModel extends ITourSelectItemViewModel {
}

export interface ITourSelectControllerModel extends ITourSelectViewModel {
}

export enum ITourSelectType {
    Undef = 0,
    List = 1,
    GridTile = 2,
    GridFeatured = 3,
    LastValue = 4,
}
